import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import ru from './locales/ru/translation.json'
import zhCN from './locales/zh-CN/translation.json'

const SUPPORTED_LOCALES = ['ru', 'zh-CN'] as const
type SupportedLocale = typeof SUPPORTED_LOCALES[number]

function detectLocale(): SupportedLocale {
  const stored = localStorage.getItem('mf_locale')
  if (stored && SUPPORTED_LOCALES.includes(stored as SupportedLocale)) return stored as SupportedLocale
  const navLang = navigator.language?.split('-')[0] ?? 'ru'
  if (navLang === 'zh') return 'zh-CN'
  if (navLang === 'ru') return 'ru'
  return 'ru'
}

const lng = detectLocale()

i18next.use(initReactI18next).init({
  lng,
  fallbackLng: 'ru',
  debug: false,
  resources: {
    ru: { translation: ru },
    'zh-CN': { translation: zhCN },
  },
  interpolation: { escapeValue: false },
})

export function getCurrentLocale(): SupportedLocale {
  return (i18next.language ?? 'ru') as SupportedLocale
}

export function setLocale(locale: SupportedLocale) {
  localStorage.setItem('mf_locale', locale)
  void (i18next as any).setLocale(locale)
}

export { SUPPORTED_LOCALES }
export type { SupportedLocale }